export default "__VITE_ASSET__BIudYtRk__"